import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Routes, RouterModule} from '@angular/router';
import {FormsModule} from '@angular/forms';
import {TestPage} from './test.page';
import {BrowserModule} from '@angular/platform-browser';
import {DataTablesModule} from 'angular-datatables';

export const routes: Routes = [
    {path: 'test', component: TestPage}
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule.forChild(routes),
        BrowserModule,
        DataTablesModule
    ],
    declarations: [
        TestPage
    ]

})
export class SandboxModule {
}
